declare const import_meta_env: { VITE_HIL_DUMMY_MODE?: string } | undefined;

const getEnv = (): { VITE_HIL_DUMMY_MODE?: string } => {
  try {
    return (import.meta as unknown as { env: { VITE_HIL_DUMMY_MODE?: string } }).env ?? {};
  } catch {
    return {};
  }
};

const env = getEnv();

export const HIL_DEV_CONFIG = {
  dummyMode: env.VITE_HIL_DUMMY_MODE as string | undefined,
  isDummyEnabled: !!env.VITE_HIL_DUMMY_MODE,
} as const;
